"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function UnderlineIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M15.263,2.886h3.036v7.294c0,2.053-0.543,3.647-1.628,4.784c-1.085,1.136-2.625,1.705-4.62,1.705s-3.538-0.564-4.63-1.694 s-1.638-2.728-1.638-4.795V2.886h3.035v7.294c0,2.449,1.078,3.673,3.233,3.673c2.141,0,3.212-1.224,3.212-3.673V2.886z" }),
        react_1.default.createElement("path", { d: "M4.379,21.114V18.81h15.243v2.304H4.379z" })));
}
exports.default = UnderlineIcon;
